import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
export default (message, toastId, position = toast.POSITION.BOTTOM_RIGHT) => {
  // eslint-disable-next-line no-console
  toast.error(message || 'error', {
    position: position,
    toastId,
  });
};
